import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { Equipment } from "../../types/types";

export const useRefreshEquipments = () => {
  const setEquipments = useAppStore(store => store.setEquipments);

  const [{ response: equipmentsData }, doFetchEquipment] = useFetch(
    `/directories/equipment_items`
  );

  useEffect(() => {
    let equipments = equipmentsData?.data as unknown as Equipment[];
    if (equipments) {
      setEquipments(equipments)
    };
  }, [equipmentsData]);

  return doFetchEquipment;
};
